import React from 'react';

// Styles
import { StyledSection, StyledTemplateContainer } from './plansummary.styled';

// Types
import { IPlanSummaryTemplateProps } from './planSummary.types';

// Components
import PlanLogoAndLink from './templateSections/PlanLogoAndLink';
import PlanInfoTable from './templateSections/PlanInfoTable';
import ViewBenefitButton from './templateSections/ViewBenefitButton';
import PolicyInformation from './templateSections/PolicyInformation';
import PaymentInfo from './templateSections/PaymentInfo';
import ContactInformation from './templateSections/ContactInformation';
import CoveredFamilyMembers from './templateSections/CoveredFamilyMembers';
import DisenrollPlanAction from './templateSections/DisenrollPlanAction';

const PlanSummaryTemplate = ({ plan, allowDisenrollCTA }: IPlanSummaryTemplateProps) => (
    <>
        <StyledTemplateContainer as="div" data-testid="plan-summary">
            <StyledSection>
                <PlanLogoAndLink plan={plan} />
                <PlanInfoTable plan={plan} />
                <ViewBenefitButton coverageStartDate={plan.coverageStartDate} planId={plan.planId} />
            </StyledSection>
            <StyledSection>
                <PolicyInformation plan={plan} />
                <PaymentInfo plan={plan} />
                <ContactInformation plan={plan} />
                <CoveredFamilyMembers coveredMembers={plan.coveredMembers} />
                <DisenrollPlanAction plan={plan} hasPermission={allowDisenrollCTA} />
            </StyledSection>
        </StyledTemplateContainer>
    </>
);

export default PlanSummaryTemplate;
